import { memo } from 'react';
import QueryString from 'qs';
import ApiaApi, { makeApiaUrl } from '../../../../../api/apiaApi/apiaApi';
import { TApiaFunction, TApiaLoad } from '../../../../../types';
import { arrayOrArray } from '../../../../../utils/util';
import { TResponsiveTableCellRenderer } from '../../../../common/generic/responsiveTable/types';
import actions from '../../../../../api/apiaApi/actions';
import makeAccordionAsyncRenderer from '../../../../common/generic/responsiveTable/renderers/makeAccordionAsyncRenderer';

const InnerRender: TResponsiveTableCellRenderer = makeAccordionAsyncRenderer(
  async (row) => {
    const result = await ApiaApi.post<
      TApiaLoad<
        TApiaFunction<{
          row: { cell: { label: string; name: string } };
        }>
      >
    >(
      makeApiaUrl({
        action: actions.common.lists.adtInfo,
        isAjax: true,
        preventAsXmlParameter: true,
      }),
      {
        postData: QueryString.stringify({
          id: row.id.slice(
            0,
            row.id.indexOf('$-$') > 0 ? row.id.indexOf('$-$') : row.id.length,
          ),
        }),
      },
    );
    if (result && result.data) {
      const resultCells = arrayOrArray(
        arrayOrArray(result.data.function.messages.row)[0].cell,
      );

      if (typeof resultCells !== 'string') {
        return resultCells.map((cell) => {
          const { name } = cell;
          const { label } = cell;
          return { name, label };
        });
      }
    }
    return [];
  },
);
const AccordionAsyncRenderer = memo(InnerRender);

export default AccordionAsyncRenderer;
